<template>
  <div class="big mydialog">
    <div class="page_title flex_between">
      <span>暂停收货地提示</span>
      <span>
        <el-button
          type="primary"
          :disabled="
            module_id_array[0] ? !module_id_array.includes('690') : false
          "
          style="width: 100px"
          @click="submit"
          >发布</el-button
        >
        <el-button
          plain
          :disabled="
            module_id_array[0] ? !module_id_array.includes('691') : false
          "
          style="width: 100px"
          @click="toHistory"
          >历史记录</el-button
        >
      </span>
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="flex_between">
          <span>
            <span style="font-weight: 700; margin-right: 20px"
              >暂停收货地设置</span
            >
            <span>{{ province_city_name }}</span>
          </span>
          <span>
            <el-button plain size="medium" @click="reSet">重置</el-button>
          </span>
        </div>
        <div class="areabox">
          <div class="areaitem">
            <div>
              <div
                v-for="(pro, index) in areaData"
                :key="index"
                class="provinceitem"
              >
                <span
                  class="province"
                  @click="choosePro(pro, index)"
                  :style="{ color: pro.isChecked ? '#0DB24D' : '#333' }"
                  >{{ pro.name }}</span
                >
                <span
                  v-for="(city, ind) in pro.city"
                  :key="ind"
                  :style="{ color: city.isChecked ? '#0DB24D' : '#999' }"
                  @click="chooseCity(city, pro, index, ind)"
                  >{{ city.name }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <div style="font-weight: 700; margin: 20px 0 10px">事件备注</div>
        <div>
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            placeholder="请输入内容"
            v-model="remark"
          >
          </el-input>
        </div>
        <div style="font-weight: 700; margin: 20px 0 10px">患者端提示信息</div>
        <div>
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            placeholder="请输入内容"
            v-model="patient_msg"
          >
          </el-input>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
export default {
  data() {
    return {
      areaData: [],
      provinces_id: '',
      cities_id: '',
      province_city_name: '',
      remark: '',
      patient_msg: ''
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取暂停收货地信息
    getPlatformAreaExpress() {
      this.axios
        .post('platform/activity/getPlatformAreaExpress')
        .then((res) => {
          let info = res.data.info;
          this.provinces_id = info.provinces_id;
          this.cities_id = info.cities_id;
          this.province_city_name = info.province_city_name;
          this.remark = info.remark;
          this.patient_msg = info.patient_msg;
        });
      this.getAreaList();
    },
    //获取省份-城市
    getAreaList() {
      this.axios
        .post('platform/platform/getProvinceCityDistrict')
        .then((res) => {
          let areaData = [];
          areaData = res.data.list;
          areaData.forEach((item) => {
            item.isChecked = false;
            item.city.forEach((city) => {
              city.isChecked = false;
            });
          });
          this.areaData = areaData;
          let pro_id = [];
          let city_id = [];
          if (!this.provinces_id && !this.cities_id) {
            pro_id = [];
            city_id = [];
          } else {
            pro_id = this.provinces_id.split(',');
            city_id = this.cities_id.split(',');
          }
          this.areaData.forEach((item) => {
            item.isChecked = false;
            let a = 0;
            item.name = item.name.replace(/\([^\)]*\)/g, '');
            if (pro_id.includes(item.province_id + '')) {
              item.isChecked = true;
              a = 1;
            }
            item.city.forEach((city) => {
              city.isChecked = false;
              if (city_id.includes(city.city_id + '')) {
                city.isChecked = true;
              }
            });
            if (a) {
              item.isChecked = true;
            }
          });
        });
    },
    //选择省
    choosePro(pro) {
      pro.isChecked = !pro.isChecked;
      pro.city.forEach((ele) => {
        ele.isChecked = pro.isChecked;
      });
      this.chooseAdd();
    },
    //选择市
    chooseCity(city, pro, index) {
      pro.isChecked = false;
      city.isChecked = !city.isChecked;
      this.areaData[index].city.forEach((i) => {
        let a = 0;
        if (i.isChecked) {
          a = 1;
        }
        if (a) {
          pro.isChecked = true;
        }
      });
      this.chooseAdd();
    },
    //选择的地区
    chooseAdd() {
      let proData = [];
      let cityData = [];
      this.areaData.map((pro) => {
        if (pro.isChecked) {
          let a = 0;
          let b = 0;
          pro.city.map((city) => {
            if (!city.isChecked) {
              a = 1;
            } else {
              b += 1;
            }
          });
          if (a) {
            pro.pro_name = pro.name + '(' + b + '/' + pro.city.length + ')';
          } else {
            pro.pro_name = pro.name;
          }
          proData.push(pro);
        }
        pro.city.map((city) => {
          if (city.isChecked) {
            cityData.push(city);
          }
        });
      });
      let pro_id = [];
      let city_id = [];
      let pros = [];
      pros = proData.map((item) => {
        return item.pro_name;
      });
      pro_id = proData.map((item) => {
        return item.province_id;
      });
      city_id = cityData.map((item) => {
        if (item.isChecked) {
          return item.city_id;
        }
      });
      this.provinces_id = pro_id.toString();
      this.cities_id = city_id.toString();
      this.province_city_name = pros.toString();
    },
    //重置
    reSet() {
      this.areaData.forEach((item) => {
        item.isChecked = false;
        item.city.forEach((city) => {
          city.isChecked = false;
        });
      });
      this.chooseAdd();
    },
    //发布
    submit() {
      if (!this.remark || !this.patient_msg) {
        this.$message.error('请填写完整相关信息');
        return false;
      }
      let data = {
        cities_id: this.cities_id,
        provinces_id: this.provinces_id,
        province_city_name: this.province_city_name,
        remark: this.remark,
        patient_msg: this.patient_msg
      };
      this.axios
        .post('platform/activity/savePlatformAreaExpress', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('发布成功');
            this.getPlatformAreaExpress();
          }
        });
    },
    //历史记录
    toHistory() {
      this.$router.push('historylist');
    }
  },
  created() {
    this.getPlatformAreaExpress();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.areabox {
  margin-top: 10px;
  width: 100%;
  height: 446px;
  border: solid 1px #c9cbd6;
  overflow-y: scroll;
  box-sizing: border-box;
  .areaitem {
    .provinceitem {
      padding: 5px;
      line-height: 30px;
      border-bottom: 1px solid #e8e9f0;
      box-sizing: border-box;
      .province {
        display: inline-block;
        width: 120px;
        padding-left: 10px;
      }
      div {
        margin: 10px 0;
        width: 550px;
      }
      span {
        margin-right: 15px;
        display: inline-block;
        margin-bottom: 5px;
        color: #999;
        cursor: pointer;
      }
      span:first-child {
        color: #333;
        padding-right: 10px;
        border-right: 2px solid #e8e9f0;
        margin-bottom: 5px;
      }
    }
  }
}
</style>